<!--
 * @Author: zhonghao
 * @Date: 2023-09-20 09:53:08
-->
<template>
  <div
    class="study-report with-annual-entry"
    @click="isTips = false"
  >
    <div class="study-con">
      <div class="txt1">
        <img src="../../assets/images/person/Frame.png" alt="" style="width: 24px;">
        <span>学习报告</span>
        <img src="../../assets/images/person/tips2@2x.png" @click.stop="isTips = true" class="tips2" alt="">
        <div class="tips" v-if="isTips">
          <img src="../../assets/images/person/tips@2x.png" class="tips-img" alt="">
          <div class="txt">
            每日8点刷新上一日学习数据
          </div>
        </div>
      </div>
      <div class="txt2">{{ details && details.time }}您来啦,在这里学习了{{ details.studyDay ? details.studyDay : 0 }}天</div>
      <div class="txt3">一份耕耘一份收获，来查看您在iEP的表现</div>
      <div class="con-blocks">
        <div class="block-title">累计关键动作</div>
        <div class="block-flex">
          <div class="flex-items">
            学习了 <span class="item-num"> {{ details.studyCourseNumber ? details.studyCourseNumber : 0 }} </span> 门课程
          </div>
          <div class="flex-items">
            上传了 <span class="item-num"> {{ details.uploadCaseNumber ? details.uploadCaseNumber : 0 }} </span> 篇病例
          </div>
          <div class="flex-items">
            参加了 <span class="item-num"> {{ details.joinLiveNumber ? details.joinLiveNumber : 0 }} </span> 场直播
          </div>
          <div class="flex-items">
            参加了 <span class="item-num"> {{ details.joinActivityNumber ? details.joinActivityNumber : 0 }} </span> 场学术活动
          </div>
          <div class="flex-items">
            查看了 <span class="item-num"> {{ details.viewLiteratureNumber ? details.viewLiteratureNumber : 0 }} </span> 篇文献
          </div>
          <div class="flex-items">
            查看了 <span class="item-num"> {{ details.viewCaseNumber ? details.viewCaseNumber : 0 }} </span> 篇病例
          </div>
        </div>
      </div>
      <div class="con-blocks">
        <div class="block-title">每日一题,答题统计</div>
        <div class="block-flex">
          <div class="block-item">
            <div class="block-info">
              <div class="block-txt1">正确率</div>
              <div class="block-txt2">{{ details.accuracy ? details.accuracy : 0 }}%</div>
            </div>
            <img src="../../assets/images/person/me_icon_statistics_correct@2x.png" class="block-img" alt="">
          </div>
          <div class="block-item">
            <div class="block-info">
              <div class="block-txt1">最长连续答题天数</div>
              <div class="block-txt2">{{ details.longestAnswerDay ? details.longestAnswerDay : 0 }}天</div>
            </div>
            <img src="../../assets/images/person/me_icon_statistics_continuous@2x.png" class="block-img" alt="">
          </div>
          <div class="block-item">
            <div class="block-info">
              <div class="block-txt1">答题数量</div>
              <div class="block-txt2">{{ details.questionNum ? details.questionNum : 0 }}</div>
            </div>
            <img src="../../assets/images/person/me_icon_statistics_number@2x.png" class="block-img" alt="">
          </div>
          <div class="block-item">
            <div class="block-info">
              <div class="block-txt1">答题量用户排名</div>
              <div class="block-txt2">第 {{ details.answerNumRanking ? details.answerNumRanking : 0 }} 名</div>
            </div>
            <img src="../../assets/images/person/me_icon_statistics_ranking@2x.png" class="block-img" alt="">
          </div>
        </div>
      </div>
      <div class="con-blocks echart">
        <div class="block-title">本周课程学习时长</div>
        <div class="block-tip">
          本周学习
          <span class="col">{{ details.weekStudyCourseNumber ? details.weekStudyCourseNumber : 0 }}</span>
          分钟,比上周
          <span class="col">{{ details.weekStudyCourseMinuteRate ? details.weekStudyCourseMinuteRate : 0 }}%</span>
          <!-- 上升（rise）；下降（fall）；持平（flat）） -->
          <img src="../../assets/images/person/me_icon_rise@2x.png" v-if="details.weekStudyCourseMinuteMark === 'rise'"
            class="block-tip-icon" alt="">
          <img src="../../assets/images/person/me_icon_decline@2x.png"
            v-else-if="details.weekStudyCourseMinuteMark === 'fall'" class="block-tip-icon" alt="">
          <img src="../../assets/images/person/me_icon_Flat@2x.png" v-else-if="details.weekStudyCourseMinuteMark === 'flat'"
            class="block-tip-icon" alt="">
        </div>
        <div id="echarts1" class="div-echart"></div>
      </div>
    </div>
    <div class="annual-report-entry">
      <div
        class="annual-btn"
        v-track="{ functionName: '专属的学习报告-2025年度学习报告' }"
        @click.stop="goAnnualReport"
      >
        年度学习报告
      </div>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { getLearningReport } from '../../api/api'
import returnBack from './components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'

const UserProfile = {
  components: {
    returnBack
  },
  data () {
    return {
      details: {},
      isTips: false,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  async mounted () {
    // 年度报告按钮一直显示
    const typeSource = this.$route.query.typeSource
    const iepOpenId = this.$route.query.iepOpenId
    let url = null
    if ((typeSource === 'grade' || typeSource === 'cartoJourney') && iepOpenId) {
      url = getLearningReport({ openId: iepOpenId })
    } else {
      url = getLearningReport({ openId: this.userInfo.iepOpenId })
    }
    url.then(res => {
      if (!res.data) {
        return
      }
      this.details = res.data
      this.details.time = this.$moment(this.details.registerDate).format('YYYY年MM月DD日')
      var chartDom = document.getElementById('echarts1')
      var myChart = echarts.init(chartDom)
      var option
      option = {
        color: ['#4A3AFF', '#EB1700'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['上周', '本周'],
          textStyle: {
            fontSize: '13px',
            color: '#797979'
          },
          itemHeight: 5,
          itemWidth: 15,
          x: 'right',
          y: 'top'
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '3%',
          top: '40%',
          containLabel: true
        },
        toolbox: {
        },
        xAxis: {
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          axisLine: {
            lineStyle: {
              color: '#E5E5EF', // 最左侧Y轴颜色
            }
          },
          nameTextStyle: {
            color: '#C9C7D7', // 坐标轴名称的颜色
            fontStyle: 'normal', // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
            fontWeight: 'normal', // 文字字体的粗细（'normal'，无样式；'bold'，加粗；'bolder'，加粗的基础上再加粗；'lighter'，变细；数字定义粗细也可以，取值范围100至700）
            fontSize: '10', // 文字字体大小
          },
        },
        yAxis: {
          type: 'value',
          name: '(单位:分钟)',
          nameTextStyle: {
            color: '#C9C7D7', // 坐标轴名称的颜色
            fontStyle: 'normal', // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
            fontWeight: 'normal', // 文字字体的粗细（'normal'，无样式；'bold'，加粗；'bolder'，加粗的基础上再加粗；'lighter'，变细；数字定义粗细也可以，取值范围100至700）
            fontSize: '12', // 文字字体大小
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E5E5EF', // 最左侧Y轴颜色
            }
          },
          splitLine: {
            lineStyle: {
              color: '#E5E5EF', // 最左侧Y轴颜色
              type: 'dotted'
            }
          }
        },
        series: [
          {
            name: '上周',
            type: 'line',
            data: [this.details.lastMonStudyCourseMinuteNumber,
              this.details.lastTueStudyCourseMinuteNumber,
              this.details.lastWedStudyCourseMinuteNumber,
              this.details.lastThuStudyCourseMinuteNumber,
              this.details.lastFriStudyCourseMinuteNumber,
              this.details.lastSatStudyCourseMinuteNumber,
              this.details.lastSunStudyCourseMinuteNumber]
          },
          {
            name: '本周',
            type: 'line',
            data: [this.details.monStudyCourseMinuteNumber,
              this.details.tueStudyCourseMinuteNumber,
              this.details.wedStudyCourseMinuteNumber,
              this.details.thuStudyCourseMinuteNumber,
              this.details.friStudyCourseMinuteNumber,
              this.details.satStudyCourseMinuteNumber,
              this.details.sunStudyCourseMinuteNumber]
          },
        ]
      }
      option && myChart.setOption(option)
    })
  },
  methods: {
    goAnnualReport () {
      const entrance = '104'
      this.$router.push({
        path: '/annualReport',
        query: {
          entrance,
          channel: entrance
        }
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.study-report {
  width: 100%;
  position: relative;
  background: #F9F8F7;
  min-height: 100vh;

  &.with-annual-entry {
    .study-con {
      padding-bottom: 72px;
    }
  }

  .study-con {
    position: relative;
    padding: 0 12px;
    box-sizing: border-box;

    .txt1 {
      padding-top: 20px;
      font-weight: 600;
      margin-bottom: 12px;
      position: relative;
      display: flex;
      align-items: center;

      span {
        margin: 0 7px;
        font-size: 24px;
        color: #EB1700;
      }
      .tips2 {
        width: 16px;
      }

      .tips {
        position: absolute;
        width: 175px;
        height: 41px;
        left: 34px;
        top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #363533;

        .tips-img {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
        }

        .txt {
          position: relative;
          font-size: 12px;
          color: #000000;
          font-weight: 400;
        }
      }
    }

    .txt2 {
      font-size: 12px;
      line-height: 16px;
      color: #000000;
      margin-bottom: 8px;
    }

    .txt3 {
      font-size: 12px;
      line-height: 16px;
      color: #000000;
      margin-bottom: 24px;
    }

    .con-blocks {
      border: 1px solid #FFFFFF;
      background: #fff;
      border-radius: 12px;
      margin-bottom: 16px;
      padding: 12px 12px 0;
      box-sizing: border-box;

      &.echart {
        padding-bottom: 20px;
        position: relative;
        background-color: #fff;

        .block-title {
          position: absolute;
        }

        .block-tip {
          display: flex;
          align-items: center;
          position: absolute;
          width: 100%;
          top: 54px;
          font-size: 13px;
          color: #797979;

          &::before {
            position: absolute;
            width: calc(100% - 28px);
            height: 1px;
            background-color: #E5E5EF;
            top: -11px;
            left: 0;
            content: '';
          }

          .col {
            font-size: 16px;
            color: #EB1700;
            font-weight: bold;
          }

          .block-tip-icon {
            display: block;
            width: 14px;
            height: 14px;
            margin-left: 4px;

          }
        }
      }

      .block-title {
        font-size: 14px;
        color: #000;
        line-height: 16px;
        margin-bottom: 12px;
        font-weight: 600;
      }

      .block-flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .flex-items {
          width: 50%;
          display: flex;
          align-items: center;
          font-size: 13px;
          color: #5D5D5D;
          padding-left: 14px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 16px;

          &::before {
            position: absolute;
            width: 8px;
            height: 8px;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            background-color: #EB1700;
            border-radius: 50%;
          }

          .item-num {
            font-size: 16px;
            color: #EB1700;
            font-weight: bold;
            margin: 0 3px;
          }
        }
      }

      .block-item {
        display: flex;
        width: 158px;
        height: 60px;
        background-color: #fff;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;
        padding-left: 14px;
        box-sizing: border-box;
        border-radius: 12px;
        margin-bottom: 10px;
        position: relative;

        .block-img {
          width: 52px;
          height: 52px;
          display: block;
          position: absolute;
          right: 0;
        }

        .block-info {
          display: flex;
          flex-direction: column;

          .block-txt1 {
            font-size: 13px;
            color: #7F7F7F;
            line-height: 16px;
            margin-bottom: 6px;
          }

          .block-txt2 {
            font-size: 16px;
            color: #000;
            line-height: 16px;
            font-weight: 600;
          }
        }
      }
    }
  }

  .div-echart {
    width: 100%;
    height: 238px;
  }

  .annual-report-entry {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px 24px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
    background: #F9F8F6;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    z-index: 10;

    .annual-btn {
      width: 327px;
      max-width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: url('../../assets/buttonBg.png') no-repeat center;
      background-size: 100% 100%;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 15px;
      color: #F7F7F7;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/studyReport.vue